module.exports = __webpack_public_path__ + "static/media/logo-dark.51c16095.svg";